import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInternetFacing = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18 34.5c-2.283 0-4.428-.433-6.435-1.3-2.008-.866-3.754-2.041-5.239-3.526-1.485-1.485-2.66-3.232-3.527-5.239C1.933 22.427 1.5 20.283 1.5 18c0-2.283.433-4.428 1.3-6.435.866-2.008 2.041-3.754 3.526-5.239 1.485-1.485 3.231-2.66 5.239-3.527C13.573 1.933 15.717 1.5 18 1.5c2.282 0 4.427.433 6.435 1.3 2.008.866 3.754 2.041 5.239 3.526 1.485 1.485 2.66 3.231 3.527 5.239.866 2.008 1.299 4.152 1.299 6.435 0 2.282-.433 4.427-1.3 6.435-.866 2.008-2.041 3.754-3.526 5.239-1.485 1.485-3.232 2.66-5.239 3.527-2.008.866-4.152 1.299-6.435 1.299Zm-1.774-2.516V28.6c-.962 0-1.773-.357-2.433-1.072a3.59 3.59 0 0 1-.99-2.517v-1.814L4.345 14.74c-.137.55-.234 1.093-.288 1.63-.055.536-.083 1.079-.083 1.629 0 3.575 1.162 6.696 3.486 9.364 2.323 2.667 5.245 4.207 8.765 4.62Zm12.128-4.455a13.67 13.67 0 0 0 2.743-4.435c.619-1.636.928-3.334.928-5.094 0-2.915-.797-5.562-2.392-7.94-1.595-2.38-3.727-4.119-6.394-5.219v.743a3.59 3.59 0 0 1-.99 2.516c-.66.715-1.471 1.072-2.434 1.072h-3.589v3.59c0 .467-.185.852-.557 1.154-.37.303-.79.454-1.258.454h-3.423V18H21.63c.468 0 .853.179 1.155.536.302.358.454.77.454 1.238v5.238h1.773c.798 0 1.5.234 2.104.702a3.49 3.49 0 0 1 1.238 1.815Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgInternetFacing);
export { ForwardRef as ReactComponent };
